function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IfacebookCircle = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    notChangeable: true,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "16",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3933 23.9999V16.7016H19.843L20.2098 13.8573H17.3933V12.0413C17.3933 11.2178 17.622 10.6565 18.8029 10.6565L20.3091 10.6558V8.11195C20.0485 8.07742 19.1545 8 18.1144 8C15.9428 8 14.4561 9.32545 14.4561 11.7597V13.8573H12V16.7016H14.456V24L17.3933 23.9999Z",
    fill: "white"
  }));
});